import DOMPurify from 'dompurify'
import type { FC } from 'react'

import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import { convertLinkFromHTML, isHTML } from '~/core/utilities/common'
import { isBrowser } from '~/core/utilities/is-browser'

const HTMLDisplay: FC<{
  isConvertLinkFromHTML?: boolean
  content?: string
  className?: string
}> = ({ isConvertLinkFromHTML, content, className = 'text-sm text-gray-900' }) => {
  if (!content) return null

  // Prepare content
  const processedContent = isConvertLinkFromHTML ? convertLinkFromHTML(content) : content

  // Sanitize content only in browser (DOMPurify requires window object)
  const sanitizedContent = isBrowser() ? DOMPurify.sanitize(processedContent) : processedContent

  return (
    <>
      {isHTML(content) ? (
        <div
          className={cn(
            'prose dark:prose-invert prose-p:!my-0 min-w-[-webkit-fill-available] break-words',
            className
          )}
          dangerouslySetInnerHTML={{
            __html: sanitizedContent
          }}
        />
      ) : (
        <TypographyText className={className}>{content}</TypographyText>
      )}
    </>
  )
}

export default HTMLDisplay
